import React from "react";
import { useSelector } from "react-redux";
import {
  makeStyles,
  Typography,
  Tooltip,
  Box,
  IconButton,
} from "@material-ui/core";
import { FaRegCalendarAlt, FaUser, FaRegStar } from "react-icons/fa";
import { GoChevronDown } from "react-icons/go";
import { MdAdd } from "react-icons/md";
import withCopyScenario from "app/common/scenario/copy/withCopyScenario";
import withEditScenario from "app/common/scenario/withEditScenario";
import withExportScenario from "app/common/scenario/withExportScenario";
import withDeleteScenario from "app/common/scenario/withDeleteScenario";
import withImportScenario from "app/common/scenario/import/withImportScenario";
import { BsTrash, BsFiles, BsPencil } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";
import { ReactComponent as ImportCsvIcon } from "resources/import-csv-icon.svg";
// import { ReactComponent as StarIcon } from "resources/star-icon.svg";
import { CgChart } from "react-icons/cg";
// import { isCycleTypeById } from "lib/utils/cycles";
import CannibalizationTooltipComponent from "app/cannibalization/CannibalizationTooltipComponent";
import ScenarioSelectorComponent from "./ScenarioSelectorComponent";
import ScenarioMapComponent from "./map/ScenarioMapComponent";
import ScenarioMapComponentOld from "./mapOld/ScenarioMapComponentOld";

const useStyles = makeStyles((theme) => ({
  drawerHeader: {
    width: "260px",
  },
  scenarioTitleContainer: {
    display: "flex",
    marginBottom: "10px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  addScenarioButton: {
    height: "40px",
    padding: "0px",
    width: "40px",
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    "&:hover": {
      backgroundColor: "#D45F59",
    },
  },
  withLeftPadding: {
    paddingLeft: "5px",
  },
  alignCenterFlex: {
    display: "flex",
    alignItems: "center",
  },
  iconButton: {
    padding: 10,
    color: "#e2e2e2",
  },
  uncontrolledText: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: "250px",
    whiteSpace: "nowrap",
  },
  scenarioTitle: {
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
  },
  scenarioMetadataSection: {
    padding: "15px 15px",
    backgroundColor: "#fafafa",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  scenarioMetadataContainer: {
    backgroundColor: "transparent",
  },
  scenarioMetadataCard: {
    border: "1px solid #e0e0e0",
    borderTop: "0px",
    backgroundColor: "white",
    borderBottomLeftRadius: "5px",
    borderBottomRightRadius: "5px",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
  },
  scenarioSelector: {
    display: "flex",
    padding: "10px",
    alignItems: "center",
    backgroundColor: "#ffffff",
    justifyContent: "space-between",
    borderTop: "1px solid #e0e0e0",
    borderLeft: "1px solid #e0e0e0",
    borderRight: "1px solid #e0e0e0",
    border: "1px solid #e0e0e0",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px",
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#ECEFF1",
    },
  },
  scenarioMetadataCardScenarioInfo: {
    padding: "10px",
    "& > *": {
      marginTop: "5px",
      "&:first-child": {
        marginTop: 0,
      },
    },
  },
  scenarioActions: {
    display: "flex",
    justifyContent: "space-evenly",
    borderTop: "1px solid #e2e2e2",
    padding: "10px",
  },
}));

export default function ScenarioSidebarComponent() {
  const classes = useStyles();
  const scenariosSlice = useSelector((state) => state.scenarios);
  const [
    scenarioSelectorAnchorEl,
    setScenarioSelectorAnchorEl,
  ] = React.useState(null);

  const [scenarioMapAnchorEl, setScenarioMapAnchorEl] = React.useState(null);
  const [isScenarioInfoFlipped, setIsScenarioInfoFlipped] = React.useState(
    false
  );
  const configCatSlice = useSelector((state) => state.auth.configCatUser);
  // const cycleSlice = useSelector((state) => state.cycle);

  const handleScenarioMetadataClick = () => {
    setIsScenarioInfoFlipped(!isScenarioInfoFlipped);
  };

  const handleScenarioSelectorClick = (event) => {
    setScenarioSelectorAnchorEl(event.currentTarget);
  };

  const handleAddScenarioClick = (event) => {
    event.stopPropagation();
    setScenarioMapAnchorEl(event.currentTarget);
  };

  // const checkTradePromotionAnnual = () => {
  //   return (
  //     isCycleTypeById(
  //       scenariosSlice.selectedScenario.scenario.cycle.cycle_type_id,
  //       cycleSlice
  //     ) === "Pricing 2.0"
  //   );
  // };

  const buttonWithBehavior = (withFunction, scenario, icon, title) =>
    withFunction(
      (p) => (
        <Tooltip title={title} disableFocusListener>
          <IconButton
            aria-label="expand row"
            size="small"
            classes={{
              root: classes.expandButton,
            }}
            disabled={
              configCatSlice?.features?.IsMaintenanceActive &&
              title === "Copy scenario"
            }
            disableRipple
            onClick={(e) => {
              e.stopPropagation();
              p.onClick(e);
            }}
          >
            {icon}
          </IconButton>
        </Tooltip>
      ),
      scenario
    );

  const ButtonWithCopyScenario = buttonWithBehavior(
    withCopyScenario,
    scenariosSlice.selectedScenario,
    <BsFiles size={20} />,
    "Copy scenario"
  );

  const ButtonWithExportScenario = buttonWithBehavior(
    withExportScenario,
    scenariosSlice.selectedScenario.scenario,
    <RiFileExcel2Line size={20} />,
    "Export to Excel"
  );

  const ButtonWithImportCsvScenario = buttonWithBehavior(
    withImportScenario,
    scenariosSlice.selectedScenario,
    <ImportCsvIcon size={20} />,
    "Import prices from .csv"
  );

  const ButtonWithEditScenario = buttonWithBehavior(
    withEditScenario,
    scenariosSlice.selectedScenario,
    <BsPencil size={20} />,
    "Edit scenario"
  );

  const ButtonWithDeleteScenario = buttonWithBehavior(
    withDeleteScenario,
    scenariosSlice.selectedScenario.scenario,
    <BsTrash size={20} />,
    "Delete scenario"
  );

  return (
    <>
      <div className={`${classes.drawerHeader}`}>
        <div className={classes.scenarioMetadataSection}>
          {scenariosSlice.selectedScenario.scenario && (
            <>
              <div className={classes.scenarioTitleContainer}>
                {scenariosSlice.selectedScenario.scenario && (
                  <Box component="span">
                    <Typography
                      variant="body1"
                      className={`${classes.uncontrolledText} ${classes.scenarioTitle}`}
                    >
                      Scenario
                    </Typography>
                  </Box>
                )}
                <Tooltip title="Create scenario" placement="right">
                  <IconButton
                    color="primary"
                    aria-label="create scenario"
                    component="span"
                    className={classes.addScenarioButton}
                    onClick={handleAddScenarioClick}
                  >
                    <MdAdd />
                  </IconButton>
                </Tooltip>
              </div>
              <div className={`${classes.scenarioMetadataContainer}`}>
                <Box
                  component="div"
                  className={classes.scenarioSelector}
                  onClick={handleScenarioSelectorClick}
                >
                  <div style={{ display: "flex" }}>
                    <Tooltip
                      title={scenariosSlice.selectedScenario.scenario.name}
                      placement="top"
                    >
                      <Typography
                        variant="body1"
                        style={{
                          maxWidth: "150px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {scenariosSlice.selectedScenario.scenario.name}
                      </Typography>
                    </Tooltip>
                    {scenariosSlice.selectedScenario.scenario.is_starred && (
                      <div style={{ display: "flex", marginTop: "4px" }}>
                        <FaRegStar
                          size={16}
                          className={classes.icon}
                          style={{ marginLeft: "3px" }}
                          color="#747474"
                        />
                      </div>
                    )}
                    {scenariosSlice.selectedScenario.scenario.is_blocked && (
                      <CannibalizationTooltipComponent
                        placement="right"
                        iconComponent={
                          <CgChart
                            fontSize={16}
                            style={{ marginLeft: "1px" }}
                          />
                        }
                        isCustomTooltip={false}
                      />
                    )}
                  </div>
                  <GoChevronDown size={20} />
                </Box>
                <div
                  role="presentation"
                  className={classes.scenarioMetadataCard}
                  onClick={() => handleScenarioMetadataClick()}
                >
                  <div className={classes.scenarioMetadataCardScenarioInfo}>
                    <Box component="span" className={classes.alignCenterFlex}>
                      <FaRegCalendarAlt />
                      <Tooltip
                        title={
                          scenariosSlice.selectedScenario.scenario.cycle.label
                        }
                        placement="right"
                      >
                        <Typography
                          variant="body2"
                          className={`${classes.withLeftPadding} ${classes.uncontrolledText}`}
                        >
                          {scenariosSlice.selectedScenario.scenario.cycle.label}
                        </Typography>
                      </Tooltip>
                    </Box>
                    <Box
                      component="span"
                      className={`${classes.alignCenterFlex}`}
                    >
                      <FaUser />
                      <Tooltip
                        title={
                          scenariosSlice.selectedScenario.scenario
                            .owner_label || "-"
                        }
                        placement="right"
                      >
                        <Typography
                          variant="body2"
                          className={`${classes.withLeftPadding} ${classes.uncontrolledText}`}
                        >
                          {scenariosSlice.selectedScenario.scenario
                            .owner_label || "-"}
                        </Typography>
                      </Tooltip>
                    </Box>
                  </div>
                  <div className={`${classes.scenarioActions}`}>
                    <ButtonWithCopyScenario />
                    <ButtonWithExportScenario />
                    <ButtonWithImportCsvScenario />
                    {scenariosSlice.selectedScenario.scenario
                      .scenario_type_id !== 1 && (
                      <>
                        <ButtonWithDeleteScenario />
                        <ButtonWithEditScenario />
                      </>
                    )}
                    <></>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {scenarioMapAnchorEl &&
        (configCatSlice?.features?.NewScenarioMap ? (
          <ScenarioMapComponent
            scenarioMapAnchorEl={scenarioMapAnchorEl}
            setScenarioMapAnchorEl={setScenarioMapAnchorEl}
          />
        ) : (
          <ScenarioMapComponentOld
            scenarioMapAnchorEl={scenarioMapAnchorEl}
            setScenarioMapAnchorEl={setScenarioMapAnchorEl}
          />
        ))}

      {scenarioSelectorAnchorEl && (
        <ScenarioSelectorComponent
          setScenarioSelectorAnchorEl={setScenarioSelectorAnchorEl}
          scenarioSelectorAnchorEl={scenarioSelectorAnchorEl}
        />
      )}
    </>
  );
}
